export const appLinks = {
  googlePlay:
    process.env.NEXT_PUBLIC_GOOGLE_PLAY_URL ||
    process.env.NEXT_PUBLIC_ANDROID_APP_URL ||
    "https://play.google.com/store/search?q=Carevinco&c=apps",
  appStore:
    process.env.NEXT_PUBLIC_APP_STORE_URL ||
    process.env.NEXT_PUBLIC_IOS_APP_URL ||
    "https://apps.apple.com/us/iphone/search?term=Carevinco",
} as const;
